import { state$ } from "../globalState";
import { AffaireService } from "../../services/AffaireService";
import { catchError } from "../../services/DaoService";
import Toast from "../../helpers/Toast";
import { areFiltersDefault } from "../../helpers/filters";

export const affairesState = {
    async loadAffaires() {
        if (state$.affaires.list.get().length > 0 && areFiltersDefault(state$.affaires.filters.get())) {
            return; // Already loaded and no filters
        }
        state$.affaires.loading.set(true);
        try {
            const response = await AffaireService.getInstance().search(state$.affaires.filters.get());
            state$.affaires.list.set(response.data.data);
            state$.affaires.pagination.set(response.data);
        } catch (error) {
            catchError(error);
        } finally {
            state$.affaires.loading.set(false);
        }
    },

    async refreshAffaires() {
        state$.affaires.loading.set(true);
        try {
            const response = await AffaireService.getInstance().search(state$.affaires.filters.get());
            state$.affaires.list.set(response.data.data);
            state$.affaires.pagination.set(response.data);
        } catch (error) {
            catchError(error);
        } finally {
            state$.affaires.loading.set(false);
        }
    },

    async loadMoreAffaires() {
        const pagination = state$.affaires.pagination.get();
        if (pagination?.next_page_url) {
            state$.affaires.loading.set(true);
            try {
                const response = await AffaireService.post(pagination.next_page_url, state$.affaires.filters.get());
                if (response) {
                    // only append missing items
                    const existingUids = new Set(state$.affaires.list.get().map(a => a.uid));
                    let newData = response.data.data.filter(a => !existingUids.has(a.uid));
                    state$.affaires.list.push(...newData);
                    state$.affaires.pagination.set(response.data);
                }
            } catch (error) {
                catchError(error);
            } finally {
                state$.affaires.loading.set(false);
            }
        }
    },

    async deleteAffaire(uid) {
        state$.affaires.loading.set(true);
        try {
            const response = await AffaireService.getInstance().remove(uid);
            Toast.success(response.message);
            this.removeAffaireFromList(uid);
        } catch (error) {
            catchError(error);
        } finally {
            state$.affaires.loading.set(false);
        }
    },

    async getAffaire(uid) {
        let affaire = state$.affaires.list.get().find(a => a.uid === uid);
        if (!affaire) {
            try {
                affaire = await AffaireService.getInstance().find(uid);
                state$.affaires.list.push(affaire.data);
            } catch (error) {
                catchError(error);
            }
        }
        // Fetch latest version in background
        AffaireService.getInstance().find(uid).then(response => {
            this.updateAffaireInList(response.data);
        }).catch(catchError);

        return affaire;
    },

    updateAffaireInList(updatedAffaire) {
        const list = state$.affaires.list.get();
        const index = list.findIndex(a => a.uid === updatedAffaire.uid);
        if (index !== -1) {
            const newList = [...list];
            newList[index] = updatedAffaire;
            state$.affaires.list.set(newList);
        } else {
            state$.affaires.list.set([...list, updatedAffaire]);
        }
    },

    addAffaire(affaire) {
        state$.affaires.list.unshift(affaire);
    },

    updateAffaire(uid, updatedData) {
        const index = state$.affaires.list.get().findIndex(a => a.uid === uid);
        if (index !== -1) {
            state$.affaires.list[index].set(updatedData);
        }
    },

    removeAffaireFromList(uid) {
        const index = state$.affaires.list.get().findIndex(a => a.uid === uid);
        if (index !== -1) {
            state$.affaires.list.splice(index, 1);
        }
    }
};
